export default __webpack_public_path__ + "img/search_notfound.4f9caa04.svg";